import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { SecurityService } from '@core/services/system/security.service';

import { InvoicesState } from './invoices.reducer';
import { hasOpenOpenInvoiceByUuidStore, selectCounterOpenInvoiceByUuidStore } from './invoices.selectors';
import {
  ClearOpenSelfOrderInvoices,
  LoadSelfOrderInvoicesFromLocalDB,
  ReceivedNewOpenSelfOrderInvoice, RemoveOpenSelfOrderInvoice,
} from './invoices.actions';
import { Actions, ofType } from '@ngrx/effects';
import { Invoice } from '@shared/classes/invoice.class';
import { SelfOrderInvoiceStatusTypesEnum } from '@shared/constants';
import { deepCopy } from '@core/services/utils/deep-copy.util';


@Injectable()
export class InvoicesFacadeStore {

  constructor(
    private store: Store<InvoicesState>,
    private securityService: SecurityService,
    private actions$: Actions
  ) { }

  public get counterOpenSelfOrderInvoicesActiveStore(): Observable<number> {
    return this.store.select(selectCounterOpenInvoiceByUuidStore(this.securityService.activeStore?.uuid));
  }

  public get hasOpenOpenInvoiceByUuidStore(): Observable<boolean> {
    return this.store.select(hasOpenOpenInvoiceByUuidStore(this.securityService.activeStore?.uuid));
  }

  public get handleNewSelfOrderInvoice(): Observable<boolean> {
    return this.actions$.pipe(
      ofType(ReceivedNewOpenSelfOrderInvoice),
      map(({ isNew }): boolean => isNew)
    )
  }

  public loadSelfOrderInvoiceFromLocalDb(): void {
    this.store.dispatch(LoadSelfOrderInvoicesFromLocalDB());
  }

  public removeDeletedSelfOrderInvoiceFromCounter(invoice: Invoice): void {
    const selfOrderInvoice: Invoice = deepCopy(invoice);
    if (selfOrderInvoice.isSelfOrder && Boolean(selfOrderInvoice.selfOrder) && selfOrderInvoice.selfOrder.fulfillmentState === SelfOrderInvoiceStatusTypesEnum.OPEN) {
      this.store.dispatch(RemoveOpenSelfOrderInvoice({ invoice: selfOrderInvoice }));
    }
  }

  public clearSelfOrderInvoice(): void {
    this.store.dispatch(ClearOpenSelfOrderInvoices());
  }

}
